module.exports = __webpack_public_path__ + "img/logo.1017c7a2.png";